export default __webpack_public_path__ + "static/media/cup-with-handle.bb87ea83.png";